import type { PromptVideoUploadPhase } from './promptVideoUploadTracker';

const PHASE_LABEL_VIDEO: Record<PromptVideoUploadPhase, string> = {
  presigning: 'Preparing upload…',
  uploading: 'Uploading video…',
  saving: 'Saving prompt…',
  done: 'Complete',
  error: 'Upload failed',
};

const PHASE_LABEL_DOCUMENT: Record<PromptVideoUploadPhase, string> = {
  presigning: 'Preparing upload…',
  uploading: 'Uploading document…',
  saving: 'Saving document…',
  done: 'Complete',
  error: 'Upload failed',
};

export function PromptVideoUploadBar({
  progress,
  phase,
  compact = false,
  kind = 'video',
}: {
  progress: number;
  phase: PromptVideoUploadPhase;
  compact?: boolean;
  kind?: 'video' | 'document';
}) {
  const labels = kind === 'document' ? PHASE_LABEL_DOCUMENT : PHASE_LABEL_VIDEO;
  const label = labels[phase] ?? 'Uploading…';
  const pct = Math.max(0, Math.min(100, progress));

  return (
    <div className={`pv2-upload-progress${compact ? ' pv2-upload-progress--compact' : ''}`}>
      <div className="pv2-upload-progress-head">
        <span className="pv2-upload-progress-label">{label}</span>
        <span className="pv2-upload-progress-pct">{pct}%</span>
      </div>
      <div
        className="pv2-upload-progress-track"
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <div className="pv2-upload-progress-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
